<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :model="formLabelAlign"
    >
      <el-form-item label="分类名称">
        <el-input
          v-model="formLabelAlign.name"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { videoCategorystore, videoCategoryupdate } from '@/api/sourceminiprogram.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        name: ''
      },
      id: null,
      type: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    sumbit() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请输入分类名称')
        return
      }
      if (this.type === 1) {
        videoCategorystore(this.formLabelAlign).then(res => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      } else {
        videoCategoryupdate({ ...this.formLabelAlign, id: this.id }).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      }
    },
    send(type, item) {
      this.type = type
      if (this.type === 2) {
        this.formLabelAlign.name = item.name
        this.id = item.id
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
